import { JAVA_SVC } from "../config";

export async function getCountries() {
  const URL = `${JAVA_SVC}/country`;

  const response = await fetch(URL, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch countries.");
  }

  return data;
}
